module.exports = __webpack_public_path__ + "media/finish.5c10fdf2.wav";